import type { Theme } from "../store/uiStore";

export interface ChatPalette {
  // outer container
  panelBg:           string;
  panelBorder:       string;
  // message list
  listBg:            string;
  listBorder:        string;
  listEmptyText:     string;
  // header / labels
  headingText:       string;
  metaText:          string;     // "thinking…", waiting state
  // role banners
  assistantLabel:    string;
  userLabel:         string;
  // bubbles
  assistantBubbleBg: string;
  assistantBubbleText: string;
  userBubbleBg:      string;
  userBubbleText:    string;
  // example query chips
  chipBg:            string;
  chipBorder:        string;
  chipText:          string;
  // input + send
  inputBg:           string;
  inputBorder:       string;
  inputText:         string;
  inputPlaceholder:  string;
  sendBg:            string;
  sendText:          string;
  // tool call bubble (nested)
  toolBubbleBg:      string;
  toolBubbleBorder:  string;
  toolBubbleText:    string;
}

const LIGHT: ChatPalette = {
  panelBg:             "transparent",
  panelBorder:         "transparent",
  listBg:              "#ffffff",
  listBorder:          "#e5e7eb",
  listEmptyText:       "#9ca3af",
  headingText:         "#111827",
  metaText:            "#9ca3af",
  assistantLabel:      "#111827",
  userLabel:           "#1d4ed8",
  assistantBubbleBg:   "#f3f4f6",
  assistantBubbleText: "#111827",
  userBubbleBg:        "#dbeafe",
  userBubbleText:      "#1e3a8a",
  chipBg:              "#ffffff",
  chipBorder:          "#d1d5db",
  chipText:            "#374151",
  inputBg:             "#ffffff",
  inputBorder:         "#d1d5db",
  inputText:           "#111827",
  inputPlaceholder:    "#9ca3af",
  sendBg:              "#1f2937",
  sendText:            "#ffffff",
  toolBubbleBg:        "#f9fafb",
  toolBubbleBorder:    "#e5e7eb",
  toolBubbleText:      "#374151",
};

const DARK: ChatPalette = {
  panelBg:             "transparent",
  panelBorder:         "transparent",
  listBg:              "#1f2937",
  listBorder:          "#374151",
  listEmptyText:       "#9ca3af",
  headingText:         "#f9fafb",
  metaText:            "#9ca3af",
  assistantLabel:      "#f9fafb",
  userLabel:           "#93c5fd",
  assistantBubbleBg:   "#374151",
  assistantBubbleText: "#f9fafb",
  userBubbleBg:        "#1e3a8a",
  userBubbleText:      "#dbeafe",
  chipBg:              "#374151",
  chipBorder:          "#4b5563",
  chipText:            "#e5e7eb",
  inputBg:             "#111827",
  inputBorder:         "#4b5563",
  inputText:           "#f9fafb",
  inputPlaceholder:    "#6b7280",
  sendBg:              "#3b82f6",
  sendText:            "#ffffff",
  toolBubbleBg:        "#111827",
  toolBubbleBorder:    "#374151",
  toolBubbleText:      "#d1d5db",
};

export function chatPalette(theme: Theme): ChatPalette {
  return theme === "light" ? LIGHT : DARK;
}
